
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/payments",
      function () {
        return require("private-next-pages/help/payments.tsx");
      }
    ]);
  